
import { mapState, mapActions, mapGetters } from "vuex";
import appReceiverHealthIndexConfigurationItem from "./app-receiver-health-index-configuration-item.vue";
export default {
  components: { appReceiverHealthIndexConfigurationItem },
  data() {
    return {
      config: {
        orderAcceptanceTime: 10,
        foodPreparationTime: 10,
        cancellationsAllowed: 2,
        businessHours: 2
      },
      configs: [
        {
          value: 10,
          id: "health_metrics_order_acceptance_time",
          label: "Order acceptence time",
          max: 45,
          min: 5,
          unit: "sec",
          incrementBy: 5
        },
        {
          value: 600,
          id: "health_metrics_preparation_time",
          label: "Food preparation time",
          max: 2700,
          min: 300,
          unit: "min",
          incrementBy: 300
        },
        {
          value: 600,
          id: "health_metrics_pickup_time",
          label: "Food Pickup Time",
          max: 2700,
          min: 300,
          unit: "min",
          incrementBy: 300
        },
        {
          value: 600,
          id: "health_metrics_delivery_time",
          label: "Food Delivery",
          max: 2700,
          min: 300,
          unit: "min",
          incrementBy: 300
        },
        {
          value: 5,
          id: "health_metrics_cancellations_per_day",
          label: "No. of cancellations allowed per day",
          max: 50,
          min: 0,
          unit: "",
          incrementBy: 1
        },
        {
          value: 7200,
          id: "health_metrics_business_hours",
          label: "Business Hours",
          max: 86400,
          min: 3600,
          unit: "hrs",
          incrementBy: 3600
        }
      ],
      configCopy: {},
      loading: false
    };
  },
  props: {
    selectedRestaurant: {
      type: Object,
      default: {}
    }
  },
  computed: {
    ...mapState("restaurant", ["locationDetails"]),
    hasUnsavedChanges() {
      return JSON.stringify(this.configCopy) !== JSON.stringify(this.configs);
    }
  },
  beforeMount() {
    this.setConfig();
    this.createConfigCopy();
  },
  watch: {
    selectedRestaurant() {
      this.setConfig();
    }
  },
  methods: {
    ...mapActions("restaurant", ["updateRestaurantSettings"]),
    setConfig() {
      this.configs.forEach((element, index) => {
        this.configs[index].value =
          this.selectedRestaurant.settings[element.id];
      });
    },
    createConfigCopy() {
      this.configCopy = JSON.parse(JSON.stringify(this.configs));
    },
    async saveChange() {
      const $this = this;
      this.loading = true;
      let settings = {};
      this.configs.forEach((el) => {
        settings[el.id] = el.value;
      });
      try {
        await this.updateRestaurantSettings({
          settings,
          id: this.selectedRestaurant.id
        });
        this.$nuxt.$emit("show-toast", {
          text: "Configuration updated successfully",
          color: "success darken-2",
          icon: "done",
          flat: true
        });
      } catch (err) {
        this.$nuxt.$emit("show-error-toast", err);
      }
      this.loading = false;
    }
  }
};
